// Host component contract: must declare data properties otp_1..otp_6 (flat strings)
// and errorMsg, and render <input id="otp_1">..<input id="otp_6"> elements (not $refs).
export default {
  methods: {
    getOtpElement(id) {
      return window.document.getElementById(`otp_${id}`);
    },
    focusOtpBox(id) {
      this.getOtpElement(id).focus();
    },
    validatePassKey(id, event) {
      const keyCode = event.keyCode;
      const isDigitKey = /^\d$/.test(event.key);
      const sanitized = (this[`otp_${id}`] || "").replace(/\D/g, "").slice(0, 1);
      if (this[`otp_${id}`] !== sanitized) {
        this[`otp_${id}`] = sanitized;
      }
      if (isDigitKey && id !== 6) {
        this.focusOtpBox(id + 1);
      } else if ((keyCode === 8 || keyCode === 46) && id !== 1) {
        this.focusOtpBox(id - 1);
      }
      if (keyCode === 37) {
        this.focusOtpBox(id - 1);
      }
      let isBlank = false;
      for (let i = 1; i <= 6; i++) {
        if (this.getOtpElement(i).value === "") {
          isBlank = true;
          break;
        }
      }
      if (!isBlank) {
        this.errorMsg = null;
      }
    },
    handleOtpPaste(event) {
      event.preventDefault();
      const pasted = (event.clipboardData || window.clipboardData).getData("text") || "";
      const digits = pasted
        .replace(/\D/g, "")
        .slice(0, 6)
        .split("");
      if (!digits.length) {
        return;
      }
      digits.forEach((digit, index) => {
        this[`otp_${index + 1}`] = digit;
      });
      const lastFilledId = Math.min(digits.length, 6);
      this.focusOtpBox(lastFilledId);
      const isBlank = digits.length < 6;
      if (!isBlank) {
        this.errorMsg = null;
      }
    }
  }
};
